// @flow

import $ from 'jquery'

import { attachDragger } from '../../action/attach-dragger'

export default () => {
  attachDragger($('.after-light-blue'))
}
